<template>
    <div>
        <Select
            style="width: 250px;"
            placeholder="Ketik Marking"
            v-model="markingIdSelected"
            filterable
            clearable
            remote
            :remote-method="getMarkingByCode"
            @on-change="onSelectedMarking()"
            >
            <Option v-for="option in optionMarkings"
                :value="option.value"
                :key="option.value">{{option.label}}</Option>
        </Select>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'

const numeral = require('numeral');

export default {
    data: () => ({
        markingIdSelected : '',
        optionMarkings : [],
        payments : [],
        loadingSearch : false,
    }),

    methods: {
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        onSelectedMarking: function(id) {
            this.$emit("on-selected-marking", this.markingIdSelected);
        },

    },
    mounted() {
        // this.getPaymentPendingByFilter();
    },
    created() {
    }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// SelectMarking.vue?6ffd3fd4